import { render, staticRenderFns } from "./wax-carts-pkg.vue?vue&type=template&id=9da7399a&"
import script from "./wax-carts-pkg.vue?vue&type=script&lang=js&"
export * from "./wax-carts-pkg.vue?vue&type=script&lang=js&"
import style0 from "./wax-carts-pkg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9da7399a')) {
      api.createRecord('9da7399a', component.options)
    } else {
      api.reload('9da7399a', component.options)
    }
    module.hot.accept("./wax-carts-pkg.vue?vue&type=template&id=9da7399a&", function () {
      api.rerender('9da7399a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/wax-carts-pkg/wax-carts-pkg.vue"
export default component.exports